function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { sdkLogger } from '../../logger';
import { isIon } from '../../utils/device-type';
var PARALLEL = 4;
var TIMEOUT = 5000;
var ION_REQUEST_TIMEOUT = 5000;
export var PixelFetch = /*#__PURE__*/ function() {
    "use strict";
    function PixelFetch(context) {
        _class_call_check(this, PixelFetch);
        _define_property(this, "context", void 0);
        this.context = context;
    }
    _create_class(PixelFetch, [
        {
            key: "fetch",
            value: function fetch(src) {
                if (isIon()) {
                    this.throttledFetch(src);
                } else {
                    this.pixelFetch(src);
                }
            }
        },
        {
            key: "throttledFetch",
            value: function throttledFetch(src) {
                var _this = this;
                if (PixelFetch.active.length >= PARALLEL) {
                    sdkLogger.verbose("pixel-fetch:pending:".concat(src));
                    PixelFetch.pending.push(src);
                    return;
                }
                var xhr = new XMLHttpRequest();
                var handleCompletion = function() {
                    sdkLogger.verbose("pixel-fetch:complete:".concat(src));
                    // cleanup
                    xhr.onloadend = null;
                    xhr.ontimeout = null;
                    PixelFetch.active.splice(PixelFetch.active.indexOf(src), 1);
                    // TODO: filter pending requests that have outlived a reasonable TTL
                    if (PixelFetch.pending.length >= 0) {
                        var urlSrc = PixelFetch.pending.shift();
                        if (urlSrc) {
                            _this.throttledFetch(urlSrc);
                        }
                    }
                };
                PixelFetch.active.push(src);
                xhr.timeout = ION_REQUEST_TIMEOUT;
                xhr.ontimeout = function() {
                    sdkLogger.warn("pixel-fetch:timeout:".concat(src));
                };
                xhr.onloadend = handleCompletion;
                sdkLogger.verbose("pixel-fetch:sending:".concat(src));
                xhr.open('GET', src);
                xhr.send();
            }
        },
        {
            key: "pixelFetch",
            value: function pixelFetch(src) {
                var _this = this;
                var imageElement = this.context.document.createElement('img');
                imageElement.style.position = 'fixed';
                imageElement.style.visibility = 'hidden';
                imageElement.width = 1;
                imageElement.height = 1;
                var timeoutId = null;
                var cleanup = function() {
                    if (!timeoutId) return;
                    clearTimeout(timeoutId);
                    timeoutId = null;
                    _this.context.document.body.removeChild(imageElement);
                    imageElement.onload = null;
                    imageElement.onerror = null;
                };
                timeoutId = setTimeout(cleanup, TIMEOUT);
                imageElement.onload = cleanup;
                imageElement.onerror = cleanup;
                this.context.document.body.appendChild(imageElement);
                imageElement.src = src;
            }
        }
    ], [
        {
            key: "reset",
            value: function reset() {
                PixelFetch.active = [];
                PixelFetch.pending = [];
            }
        }
    ]);
    return PixelFetch;
}();
_define_property(PixelFetch, "active", []);
_define_property(PixelFetch, "pending", []);

//# sourceMappingURL=pixel-fetch.js.map